import http from "./http.service";
import Promisable from "./promisable.service";
import { NavigateFunction } from "react-router-dom";
import { loaderActions } from "redux/slices/loader";
import { getAppDispatch } from "utils/dispatch.util";
import { newPricingActions } from "redux/slices/newPricing";
import { formLoaderActions } from "redux/slices/formLoader";
import { modalActions } from "redux/slices/modal";
import { newFixedPricingActions } from "redux/slices/newFixedPricing";

const url = "/new-prices";
const urlFixedPrice = "/new-fixed-price";
const urlZone = "/new-zone";
const urlClass = "/new-class";

const NewPricingService = {
    addNewPricing: async (data: any, navigate?: NavigateFunction) => {
        const dispatch = getAppDispatch();
        dispatch?.(formLoaderActions.setLoading(true));

        http.setJWT();
        http.setMultiPart();

        const [success, error]: any = await Promisable.asPromise(
            http.post(`${url}`, data)
        );

        if (success) {
            // const { price: pricing } = success.data.data;
            // dispatch?.(newPricingActions.addPricing(pricing));
            navigate?.("/pricing");
        }

        dispatch?.(formLoaderActions.setLoading(false));
        return [success, error];
    },

    updateNewPricing: async (id: string, data: any, navigate?: NavigateFunction) => {
        const dispatch = getAppDispatch();
        dispatch?.(formLoaderActions.setLoading(true));

        http.setJWT();
        http.setMultiPart();

        const [success, error]: any = await Promisable.asPromise(
            http.put(`${url}/${id}`, data)
        );

        if (success)
            navigate?.("/pricing");

        dispatch?.(formLoaderActions.setLoading(false));
        return [success, error];
    },

    getNewPricing: async (id: string) => {
        const dispatch = getAppDispatch();
        dispatch?.(loaderActions.setLoading(true));

        http.setJWT();
        const [success, error]: any = await Promisable.asPromise(
            http.get(`${url}/${id}`)
        );

        if (success) {
            const { price: pricing } = success.data.data;
            dispatch?.(newPricingActions.setPricing(pricing));
        } else dispatch?.(newPricingActions.setPricing({ data: "Not Found" }));

        dispatch?.(loaderActions.setLoading(false));
        return [success, error];
    },

    getNewPricingByClass: async (class_id: string,type:string) => {
        const dispatch = getAppDispatch();
        dispatch?.(loaderActions.setLoading(true));

        http.setJWT();

        const [success, error]: any = await Promisable.asPromise(
            http.get(`${url}/class/${class_id}?type=${type}`)
        );

        if (success) {
            const { price: pricing } = success.data.data;
            dispatch?.(newPricingActions.setPricing(pricing));
            dispatch?.(newFixedPricingActions.setPricing(pricing));
            dispatch?.(modalActions.closeModal());
        } else dispatch?.(newPricingActions.setPricing({ data: "Not Found" }));

        dispatch?.(loaderActions.setLoading(false));
        return [success, error];
    },

    getAllNewPricings: async (params?: string) => {
        const dispatch = getAppDispatch();
        dispatch?.(newPricingActions.setLoading(true));
        const query = params ? params : ""

        http.setJWT();

        const [success, error]: any = await Promisable.asPromise(
            http.get(`${url}${query}`)
        );

        if (success) {
            const { prices: pricings } = success.data.data;
            dispatch?.(newPricingActions.setPricings(pricings));
        }
        dispatch?.(newPricingActions.setLoading(false));
        return [success, error];
    },

    getAllCompanyFixedNewPricings: async (data: any) => {
        const dispatch = getAppDispatch();
        dispatch?.(newPricingActions.setLoading(true));

        http.setJWT();

        const [success, error]: any = await Promisable.asPromise(
            http.post(`${urlFixedPrice}/all`, data)
        );

        if (success) {
            const { prices: pricings } = success.data.data;
            if (pricings && pricings?.length > 0){
                dispatch?.(newPricingActions.setPricings(pricings));
            }
        }

        dispatch?.(newPricingActions.setLoading(false));
        return [success, error];
    },

    getNewPricingClasses: async () => {
        const dispatch = getAppDispatch();
        dispatch?.(newPricingActions.setLoading(true));

        http.setJWT();

        const [success, error]: any = await Promisable.asPromise(
            http.get(`${urlClass}`)
        );

        if (success) {
            const { classes } = success.data.data;
            dispatch?.(newPricingActions.setPriceClasses(classes));
        }

        dispatch?.(newPricingActions.setLoading(false));
        return [success, error];
    },

    getNewPricingAllZones: async () => {
        const dispatch = getAppDispatch();
        dispatch?.(newPricingActions.setLoading(true));

        http.setJWT();

        const [success, error]: any = await Promisable.asPromise(
            http.get(`${urlZone}`)
        );

        if (success) {
            const { zones } = success.data.data;
            dispatch?.(newPricingActions.setPriceZones(zones));
        }

        dispatch?.(newPricingActions.setLoading(false));
        return [success, error];
    },
};

export default NewPricingService; 